import {
    ActionItem,
    ActionItemProps as ActionProps,
    StartIconStyle,
} from '@modernhealth/vital-components';
import React from 'react';

import { Benefit, BenefitCategory } from '../models/benefits';

const createCategoryActionProps = (element: BenefitCategory): ActionProps => {
    return {
        title: element.alias ? element.alias : element.name,
        startIconUrl: element.image,
        startIconBackgroundColor: element.benefitColor,
    };
};

const createBenefitActionProps = (element: Benefit): ActionProps => {
    return {
        title: element.title || '',
        startIconUrl: element.imageUrl,
        description: element.providerName || '',
        startIconBackgroundColor: element.color,
    };
};

interface BenefitItemProps {
    element: Benefit;
    onClick: (e: Benefit) => void;
}

export const BenefitItem: React.FC<BenefitItemProps> = ({ element, onClick }) => {
    return (
        <ActionItem
            key={element.uuid}
            {...createBenefitActionProps(element)}
            withBorder
            startIconStyle={StartIconStyle.RoundedSquare}
            onClick={() => onClick(element)}
        />
    );
};

interface CategoryItemProps {
    element: BenefitCategory;
    onClick: (e: BenefitCategory) => void;
}

export const CategoryItem: React.FC<CategoryItemProps> = ({ element, onClick }) => {
    return (
        <ActionItem
            key={element.uuid}
            {...createCategoryActionProps(element)}
            withBorder
            startIconStyle={StartIconStyle.RoundedSquare}
            onClick={() => onClick(element)}
        />
    );
};
